/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actions used to manipulate application state
import { advanceFrame, setTotalFrameCount, setUniqueState, deactivateContents} from 'redux/actions/content_status';
import { fetchContentsData, clearContentsData } from 'redux/actions/content_data';

// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import MixedContent from 'components/content/mixed/mixed';
import { batchActions } from 'redux-batched-actions';



/* ========== ~~~~~~~~~~ MIXED CONTENT : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ contentStatus, settings, contentData, sessionStatus, embedStatus, rewards }, { contentId }) => ({
    currentContentStatus: contentStatus[contentId],
    currentContentSettings: settings.contentSettings[contentId],
    currentContentData: contentData[contentId],
    abTestVersion: embedStatus.abTestVersion,
    dataFetchingPermitted: sessionStatus.dataFetchingPermitted,
    dmpCallsEnabled: sessionStatus.dmpCallsEnabled,
    embedUUID: settings.embedSettings.uuid,
    userId: sessionStatus.userInfo.userId !== undefined ? sessionStatus.userInfo.userId : null,
    rewardsEnabled: rewards.settings.enabled,
    rewardsPermitted: rewards.status.rewardsPermitted,
    isPubPortalPreview: settings.embedSettings.isPubPortalPreview,
    frame: contentStatus[contentId].frame,
});

// map actions
const mapDispatchToProps = dispatch => ({
    advanceFrame: contentId => dispatch(advanceFrame(contentId)),
    setTotalFrameCount: (contentId, totalFrameCount) => dispatch(setTotalFrameCount(contentId, totalFrameCount)),
    setUniqueState: (contentId, uniqueState) => dispatch(setUniqueState(contentId, uniqueState)),
    setUniqueStateAndFrameCount: (contentId, uniqueState, totalFrameCount) =>
        dispatch(batchActions([
            // setUniqueState(contentId, uniqueState),
            // setTotalFrameCount(contentId, totalFrameCount)
        ])),
    // deactivateContents: contents => dispatch(deactivateContents(contents)),
    deactivateContents: contentIds =>
        dispatch(batchActions([
            deactivateContents(contentIds),
            clearContentsData(contentIds)
        ])),
    fetchContentsData: (embedUUID, contentId, cookieId, contentOrder, numberOfQuestionsLimit, isPubPortalPreview) =>
        dispatch(fetchContentsData(embedUUID, contentId, cookieId, contentOrder, numberOfQuestionsLimit, isPubPortalPreview)),
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MixedContent);
